$component-class: 'long-content-type-5';

.#{$component-class} {
  &__intro {
    .me-text {
      @include text-style('md', 'md');

      @include desktop {
        @include text-style('lg', 'md');

        max-width: 70%;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  &__carousel {
    position: relative;
  }

  &__slide {
    transition: opacity 0.3s ease-in-out;
    opacity: 1;
    will-change: opacity;

    &--transitioning {
      opacity: 0.7;
      transition: opacity 0.3s ease-in-out;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__rating {
    display: flex;
    gap: 4px;
    margin-bottom: var(--spacing-xl);

    @include desktop {
      margin-bottom: var(--spacing-2xl);
    }
  }

  &__heading {
    margin-bottom: var(--spacing-lg);

    @include desktop {
      margin-bottom: var(--spacing-xl);
    }
  }

  &__text {
    .me-heading,
    .me-text {
      margin-bottom: var(--spacing-xl);

      @include desktop {
        margin-bottom: var(--spacing-2xl);
      }
    }
  }

  &__footer {
    display: flex;
    flex-flow: column wrap;
    gap: var(--spacing-lg) var(--spacing-3xl);
    margin-top: var(--spacing-xl);

    @include desktop {
      flex-direction: row;
      align-items: center;
    }
  }

  &__logo {
    .me-logo {
      vertical-align: middle;

      img {
        max-height: px-to-rem(48px);

        @include desktop {
          max-height: px-to-rem(48px);
        }
      }
    }
  }

  &__media {
    min-height: 236px;

    @include above(640px) {
      min-height: 442px;
    }

    @include above(960px) {
      min-height: 300px;
    }

    @include above(1280px) {
      min-height: 442px;
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    // Ensure sn-how-to-decoration takes full height
    sn-how-to-decoration {
      display: block;
      height: 100%;
      min-height: inherit;
    }
  }

  &__image {
    &--avatar {
      .picture {
        border-radius: 0;
      }
    }
  }

  &__navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: var(--spacing-2xl);
    gap: var(--spacing-lg);

    @include desktop {
      margin-top: var(--spacing-3xl);
    }
  }

  &__dots {
    display: flex;
    gap: var(--spacing-sm);
    align-items: center;
    flex: 1;
    justify-content: flex-start;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: none;
    background-color: var(--color-neutral-neutral);
    cursor: pointer;
    padding: 0;
    transition:
      background-color 0.2s ease,
      transform 0.2s ease;

    &:hover {
      background-color: var(--color-neutral-black);
      transform: scale(1.2);
    }

    &:focus-visible {
      outline: 2px solid var(--color-neutral-black);
      outline-offset: 2px;
    }

    &--active {
      background-color: var(--color-neutral-black);
      transform: scale(1.2);
    }
  }

  &__arrows {
    display: flex;
    gap: var(--spacing-sm);
  }

  &__arrow {
    .me-button {
      min-width: 40px;
      min-height: 40px;
      border-radius: 50%;

      &::after {
        border-radius: 50%;
      }

      &:focus,
      &:focus-visible {
        &::after {
          inset: -4px;
          border-radius: 50%;
        }
      }
    }
  }
}
